import axios, { AxiosInstance, AxiosResponse } from "axios";
import { BACKEND_BASE_URL, V2_SERVERLESS_BASE_URL, STAGE } from "../constant/globalEnv.constant";

export const C_API: AxiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
  withCredentials: true,
});

// V2 Serverless API instance for organizations
export const V2_API: AxiosInstance = axios.create({
  baseURL: V2_SERVERLESS_BASE_URL,
  withCredentials: true,
});

// Add request interceptor to set data-region header from localStorage
const addDataRegionHeader = (config: any) => {
  const region = localStorage.getItem("data-region");
  console.log("Region from localStorage:", region);
  if (region) {
    config.headers = config.headers || {};
    config.headers["lp-data-region"] = region;
  }
  return config;
};

C_API.interceptors.request.use(addDataRegionHeader);
V2_API.interceptors.request.use(addDataRegionHeader);

export const API: AxiosInstance = axios.create({
  baseURL: BACKEND_BASE_URL,
});

let errorPageOpenedTs: Date | null = null;

const shouldOpenErrorPage = (): boolean => {
  if (!errorPageOpenedTs) {
    return true;
  }
  return new Date().getTime() - errorPageOpenedTs.getTime() >= 10 * 60 * 1000;
};

// Interceptor function
const addInternalServerErrorInterceptor = (axiosInstance: AxiosInstance): void => {
  axiosInstance.interceptors.response.use(
    (response: AxiosResponse) => response,
    (error: any) => {
      if (["dev", "local"].includes(STAGE) && error.response && error.response.status === 500) {
        if (shouldOpenErrorPage()) {
          // Construct the URL with error details as query parameters
          const errorDetails = encodeURIComponent(
            JSON.stringify({
              message: error.response?.data?.message || error.message,
              stack: error.response?.data?.data?.error || error.stack,
            })
          );
          const url = `https://api-testing-kit.vercel.app/dev?error=${errorDetails}`;
          window.open(url, "_blank");
          errorPageOpenedTs = new Date();
        }
      }
      if (error.response && error.response.status === 440) {
        if (!window.location.pathname.includes("/login")) {
          window.location.href = "/login";
        }
      }
      if (error.response && error.response.status === 401) {
        // window.location.href = "/login";
      }
      
      // Handle CORS errors
      if (error.code === 'ERR_NETWORK' || error.message?.includes('CORS') || error.message?.includes('cross-origin')) {
        console.error('CORS Error detected:', {
          message: error.message,
          code: error.code,
          stage: STAGE,
          baseURL: error.config?.baseURL,
          url: error.config?.url
        });
        
        // Show user-friendly error message
        if (STAGE === 'dev' || STAGE === 'local') {
          console.warn('If you see CORS errors, make sure your dev server is running with the proxy configuration');
        }
      }
      
      return Promise.reject(error);
    }
  );
};

// Use interceptor for all API instances
addInternalServerErrorInterceptor(C_API);
addInternalServerErrorInterceptor(API);
addInternalServerErrorInterceptor(V2_API);
